var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 172,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79 0C47.206 0 21.432 25.669 21.432 57.333V74.83c0 13.563-3.7 26.87-10.707 38.499l-5.31 8.814c-3.521 5.846-5.282 8.769-5.403 11.156a9.547 9.547 0 0 0 5.066 8.91c2.117 1.125 5.54 1.125 12.385 1.125h123.074c6.845 0 10.268 0 12.385-1.125a9.547 9.547 0 0 0 5.066-8.911c-.121-2.386-1.882-5.309-5.403-11.155l-5.31-8.814a74.59 74.59 0 0 1-10.708-38.499V57.333C136.567 25.67 110.794 0 79 0ZM102.92 154.32c.074-.788-.577-1.431-1.372-1.431H56.453c-.795 0-1.446.643-1.372 1.431.428 4.545 2.885 8.837 6.958 12.082C66.538 169.987 72.64 172 79 172c6.362 0 12.463-2.013 16.961-5.598 4.073-3.245 6.53-7.537 6.959-12.082Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.de8a35b43eb161fb875b45dff58e69c3.svg";
export { ForwardRef as ReactComponent };